module.exports = __webpack_public_path__ + "img/my_build_edit-skills-selected.3d50cb63.jpg";